import type { Experiment } from 'types';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useExperiment } from '@/state/experiments/useExperiment';
import { PXLRatingFlow } from './PXLRatingFlow';
import { PXLScoreDisplay } from './PXLScoreDisplay';
import { parsePxlScores, importanceFromScores, type PxlScores } from './pxl-scores';

type ImportanceProps = { experiment: Experiment };

export const Importance = ({ experiment }: ImportanceProps) => {
  const [pxlDialogOpen, setPxlDialogOpen] = useState(false);
  const { updateExperiment } = useExperiment(experiment.id);

  const pxlScores = parsePxlScores(experiment.pxlScores);
  const pxlCompleted = pxlScores !== null;

  const handleComplete = async (scores: PxlScores) => {
    await updateExperiment(experiment.id, { pxlScores: scores, importance: importanceFromScores(scores) });
  };

  return (
    <>
      {pxlCompleted ? (
        <PXLScoreDisplay experiment={experiment} scores={pxlScores} onEdit={() => setPxlDialogOpen(true)} />
      ) : (
        <section className="bg-panel border-line rounded-panel border" data-tour="brief-importance">
          <div className="border-line border-b px-4 py-3">
            <h2 className="micro-label text-foreground">Importance</h2>
            <p className="supporting mt-1">
              Assess the priority level and potential impact of your experiment using the PXL framework.
            </p>
          </div>
          <div className="p-4">
            <Button
              onClick={() => setPxlDialogOpen(true)}
              className="bg-cta hover:bg-ctahover h-8 w-full rounded-lg px-3 text-meta text-white"
            >
              Rate with PXL Framework
            </Button>
          </div>
        </section>
      )}
      <PXLRatingFlow
        open={pxlDialogOpen}
        onOpenChange={setPxlDialogOpen}
        onComplete={handleComplete}
        initialScores={pxlScores}
      />
    </>
  );
};
